import { render } from "./RecaptchaComponent.vue?vue&type=template&id=9cd21d36"
import script from "./RecaptchaComponent.vue?vue&type=script&lang=js"
export * from "./RecaptchaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__